import React from 'react';
import VendorsLibrary from '../vendors/VendorsLibrary';

function CouncilVendorsTab({ slug, info, api }) {
  return <VendorsLibrary api={api} base={`/${slug}/vendors`} quotesBase={`/${slug}/quotes`} canEdit={!!info.membership} practice={!!info.test} />;
}

export default CouncilVendorsTab;
